import { helper } from '@ember/component/helper'
import { formatDuration as formatDurationUtil } from 'teacher-ui-client/utils/format-duration'

interface Signature {
  Args: {
    Positional: [Nullable<number> | undefined, string | undefined]
  }
  Return: string
}

export const formatDuration = helper<Signature>(function ([valueAsSeconds, emptyValue = '']) {
  return formatDurationUtil(valueAsSeconds, emptyValue)
})

export default formatDuration
